import React, { useState, useEffect } from "react";
import location_icon from "../../ulits/images/location_icon.svg";
import dateicon from "../../ulits/images/date-icon.svg";
import CustomLoader from "../../components/CustomeLoader";
import { Link, useLocation, useNavigate, useParams } from "react-router";
import { configs } from "../../config";
import { status } from "../../_constants/commonLhd";
import { useDispatch, useSelector } from "react-redux";
import { blogAction } from "../../_actions";
import parse from "html-react-parser";
import Accordion from "react-bootstrap/Accordion";
import { configes } from "../../webData";

function BlogDetails() {
  const [loader, setLoading] = useState(true);
  const [showDiscription, setShowDiscription] = useState(false);
  const location = useLocation();
  const dispatch = useDispatch();
  const [relatedBlog, setRelatedBlog] = useState([]);
  const { slug } = useParams();
  // const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => {
      setLoading(false);
    }, 600);
  }, []);

  const blogData = useSelector((state) => state.blog.blog_data);
  const faqData = useSelector((state) => state.faq);
  const faqList =
    faqData?.faq_data?.filter((item) => item.status === true) || [];
  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => {
      setLoading(false);
    }, 600);
  }, []);

  useEffect(() => {
    if (Array.isArray(blogData) && slug) {
      const current = blogData.find((b) => b.slug === slug);
      const others = blogData.filter((b) => b.slug !== slug);

      const shuffled = [...others].sort(() => 0.5 - Math.random());

      const topRelated = shuffled.slice(0, 3);

      setBlog(current);
      setRelatedBlog(topRelated);
    }
  }, [blogData, slug]);


  const formatDate = (dateString) => {
    if (!dateString) return "";

    const [datePart] = dateString.split(",");
    const [day, month, year] = datePart.split("/");

    const date = new Date(`${year}-${month}-${day}`);
    const dayNum = date.getDate();
    const monthName = date
      .toLocaleString("en-GB", { month: "long" })
      .toUpperCase();
    const yearNum = date.getFullYear();

    const suffix = (d) => {
      if (d > 3 && d < 21) return "th";
      switch (d % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };

    return `${dayNum}${suffix(dayNum)} ${monthName} ${yearNum}`;
  };

  return (
    <>
      {loader ? (
        <CustomLoader />
      ) : (
        <div className="main-wrapper">
          <div className="blog-listing-section blog-details">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="blog-listing-box top-img">
                    <div className="blog-listing-img">
                      <img
                        src={`${configs.localApiUrl}${blog?.image}`}
                        alt=""
                      />
                    </div>
                    <div className="blog-listing-text">
                      <h1>{blog && blog.title}</h1>
                      <div className="meta-middle-unit">
                        <div className="blog-listing-date">
                          <img src={dateicon} alt="" />
                          <span>
                            {blog?.createdAt && formatDate(blog.createdAt)}
                          </span>
                        </div>
                        <div className="blog-listing-date">
                          <img src={location_icon} alt="location" />
                          <span>{blog && blog.location}</span>
                        </div>
                      </div>
                      {blog && blog.description && (
                        <>
                          <div className="desc">
                            {showDiscription ? (
                              parse(blog.description)
                            ) : (
                              <p>
                                {blog.description
                                  .replace(/<[^>]+>/g, "")
                                  .slice(0, 300)}
                                ...
                              </p>
                            )}
                          </div>

                          <div className="description">
                            <button
                              className="primary-btn-list"
                              onClick={() =>
                                setShowDiscription(!showDiscription)
                              }
                            >
                              {showDiscription ? "SHOW LESS" : "LOAD MORE"}
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="blog-listing-section">
              <div className="container">
                <div className="heading-title">
                  <h1>RELATED BLOG POSTS</h1>
                </div>
                <div className="blog-listing-wrapper">
                  {relatedBlog && relatedBlog.length > 0 ? (
                    relatedBlog.slice(0, 3).map((item, index) => {
                      // console.log("Blog Item:", item);
                      // console.log("Blog Item:", item.title);
                      return (
                        <div className="choose-us-box" key={index}>
                          <div className="blog-listing-box">
                            <div className="blog-listing-content">
                              <div className="blog-listing-img">
                                <img
                                  src={`${configs.localApiUrl}${item?.image}`}
                                  alt="blog-img"
                                />
                              </div>
                              <div className="blog-listing-title">
                                <h1>{item.title}</h1>
                                <p>
                                  {item && item.description
                                    ? parse(item.description)
                                    : null}
                                </p>
                                <div className="meta-middle-unit">
                                  <div className="blog-listing-date">
                                    <img src={dateicon} alt="" />
                                    <span>
                                      {item?.createdAt &&
                                        formatDate(item.createdAt)}
                                    </span>
                                  </div>
                                  <div className="blog-listing-date">
                                    <img src={location_icon} alt="location" />
                                    <span>{item.location}</span>
                                  </div>
                                </div>
                                <button
                                  className="primary-btn sm"
                                  onClick={() => {
                                    window.scrollTo(0, 0);
                                    navigate(`/blog-details/${item.slug}`)
                                  }
                                  }
                                >
                                  READ MORE
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <>No Blog Data</>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="stm-accordion-single-unit about-faq">
            <div className="container">
              <div className="stm-accordion-title">
                <h3>FREQUENTLY ASKED QUESTIONS</h3>
              </div>
              {faqList.length > 0 &&
                faqList.map((item, index) => (
                  <Accordion key={index}>
                    <Accordion.Item eventKey={index.toString()}>
                      <Accordion.Header>{item.que}</Accordion.Header>
                      <Accordion.Body>{item.ans}</Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default BlogDetails;
